import { KeyboardEvent } from 'react';
import { useTranslation } from '../../i18n/i18n';
import { InputAlertMessage } from './InputAlertMessage';
import { halfRow } from './InputGrid';
import { TextInput } from './TextInput';

export type NewPasswordModel = {
	newPassword: string;
	newPassword2: string;
	isValid: boolean;
};

type NewPasswordInputProps = {
	model: NewPasswordModel;
	onChange: (val: NewPasswordModel) => void;
	onKeyPress: (event: KeyboardEvent<HTMLInputElement>) => void;
	fullWidth?: boolean;
};
export const NewPasswordInput = ({ model, onChange, onKeyPress, fullWidth }: NewPasswordInputProps): JSX.Element => {
	const t = useTranslation().form;

	const { newPassword, newPassword2 } = model;
	const inputClassName = fullWidth ? undefined : halfRow;

	const longEnough = (password: string) => password.length >= 6;
	const confirmed = (p1: string, p2: string) => p1 === p2;
	const isValid = (p1: string, p2: string) => longEnough(p1) && confirmed(p1, p2);
	const hasStartedNewPassword = newPassword.length > 0;
	const hasStartedConfirmPassword = newPassword2.length > 0;

	return (
		<>
			<TextInput
				type="password"
				className={inputClassName}
				id="new-password"
				autocomplete="new-password"
				placeholder={t.newPassword}
				value={newPassword}
				isValid={hasStartedNewPassword ? longEnough(newPassword) : undefined}
				onChange={(e) =>
					onChange({
						...model,
						newPassword: e.target.value,
						isValid: isValid(e.target.value, newPassword2),
					})
				}
				onKeyDown={onKeyPress}
				nextElement="confirm-password"
			/>
			{hasStartedNewPassword && !longEnough(newPassword) && (
				<div className={inputClassName}>
					<InputAlertMessage type="error" message={t.tooFewChars} />
				</div>
			)}
			<TextInput
				type="password"
				className={inputClassName}
				id="confirm-password"
				placeholder={t.confirmNewPassword}
				value={newPassword2}
				isValid={hasStartedConfirmPassword ? confirmed(newPassword, newPassword2) : undefined}
				onChange={(e) =>
					onChange({
						...model,
						newPassword2: e.target.value,
						isValid: isValid(newPassword, e.target.value),
					})
				}
				onKeyDown={onKeyPress}
			/>
			{hasStartedConfirmPassword && !confirmed(newPassword, newPassword2) && (
				<div className={inputClassName}>
					<InputAlertMessage type="error" message={t.passwordMismatch} />
				</div>
			)}
		</>
	);
};
